var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.activateVariant)?_c('div',{staticClass:"btn",on:{"click":_setup.openModal}},[_c('FontAwesomeIcon',{attrs:{"icon":_setup.faPlay}}),_c('span',{staticClass:"btn__label"},[_vm._v("Discover with trailers")]),_c('span',{staticClass:"btn__label__highlight"},[_vm._v("New")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }